import React from 'react';

export const data = {
  title: "Somewhere Along The Way",
  rows: [
    {
      index: 0,
      title: <b>Where do I find an employee ID? </b>,
      content: "This might be an ID you have in your human resources system. Many small businesses don’t use employee IDs so you don’t have to worry about this if it doesn’t apply to you."
    },
    {
      index: 1,
      title: <b>What is an "extra period? </b>,
      content: "If you pay weekly, you could have 52 or 53 pay dates in a given calendar year, depending on how the days of the week fall in that year. e.g. There are 53 Fridays in 2021 so you have an extra period if you pay your employees every Friday. If you pay bi-weekly, you may have 26 or 27 pay dates in a given year. If you have 27 pay dates in the calendar year, then you have an extra period."
    },
    {
      index: 2,
      title: <b>Does it matter what pay period I pick/ How do I pick the pay period?</b>,
      content: "You should choose the pay frequency that best fits your business needs. The pay period you choose is up to you. Most businesses pay weekly, bi-weekly (every two weeks), semi-monthly (twice per month), or monthly. You should be consistent over time and across your workforce. i.e. If you pay one employee bi-weekly, it makes sense to pay all your employees bi-weekly. If you start the year paying semi-monthly, it is best to pay semi-monthly throughout the year."
    },
    {
      index: 3,
      title: <b>How do I add vacation amounts?</b>,
      content: "To add a vacation pay amount, click Add Another Income Type underneath the Regular Income line on the Income page. You’ll want to change it from Hourly to fixed and enter a pre-calculated amount."
    },
    {
      index: 4,
      title: <b>How do I add Year-To-Date (YTD) amounts?</b>,
      content: "In order to make YTD amounts show up on a pay stub, you need to enter previous period amounts in the YTD Income & Deductions section of the Income page.  These amounts will be added to the current period amounts and show as YTD on the pay stub.If you click on the little plus sign to the right, the YTD Income & Deductions section will open up.  Also, there is a little “?” in a circle to the left that you can click for instructions."
    },
    {
      index: 5,
      title: <b>What is an EI premium rate?</b>,
      content: "This is the multiple representing the employer portion of the EI premium in relation to the employee portion. The standard premium is 1.4 which means that the employer premium is 1.4 times the amount of the employee premium."
    },
    {
      index: 6,
      title: <b>How will I know if I've entered the information properly? </b>,
      content: "When the pay stub generated accurately represents your income and deductions, it has been entered correctly. If you’re unsure about the deductions calculated, you can use the CRA Payroll Calculator to validate the amounts. If you are still not so sure, you might want to chat with a local bookkeeper to help get you started."
    },
    {
      index: 7,
      title: <b>Can I edit a finalized pay stub?</b>,
      content: "Yep. You can use the chat button on our website to request that we unfinalize a pay stub for you. It only takes a moment and your pay stub credit can be re-used to re-finalize it when you are done."
    },
    {
      index: 8,
      title: <b>Where can I find the remittance summary?</b>,
      content: "On the pay stub preview page just underneath the pay stub. Click the link that says, “Show Remittance Summary.” It’s all there for you."
    },
    {
      index: 9,
      title: <b>Do I need to give my employee anything else?</b>,
      content: "You need to give them a T4 at the end of the year and you may need to provide a Record of Employment (ROE) when their employment is terminated."
    },   
  ]
};